import type { GetBookingsQueryParams } from '../../types/booking.js'

export const bookingKeys = {
  all: ['bookings'] as const,
  byEstimateResponse: (estimateResponseId: string) =>
    ['booking', 'estimate-response', estimateResponseId] as const,
  detail: (id: string) => ['booking', 'detail', id] as const,
  list: (params: GetBookingsQueryParams) => ['bookings', 'list', params] as const,
  myBookingByRef: (ref: string) => ['me', 'bookings', ref] as const,
  myBookings: ['me', 'bookings'] as const,
}
